<textarea
  pInputTextarea
  [attr.maxlength]="maxLength"
  [disabled]="isDisabled"
  [value]="value"
  class="plForm-element mt-1"
  (input)="onValueChange($event)"
></textarea>
